import { render, staticRenderFns } from "./component.vue?vue&type=template&id=33d5192a&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=33d5192a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d5192a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d5192a')) {
      api.createRecord('33d5192a', component.options)
    } else {
      api.reload('33d5192a', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=33d5192a&scoped=true&", function () {
      api.rerender('33d5192a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/resource/component/error/component.vue"
export default component.exports